import { Spin } from "antd";
import React, { useEffect } from "react";
import { useUser } from "../context";
import { ROUTES, UserType } from "./common";
import ManagersPanel from "./ManagersPanel";
import RecruitersPage from "./RecruitersPanel";
import CandidatesPanel from "./CandidatesPanel/CandidateDashboard";

const DashboardPage = () => {
  const { user } = useUser();
  
 
  if (user.category === UserType.MANAGER) return <ManagersPanel managerEmail={user.email} />;
  if (user.category === UserType.RECRUITER) return <RecruitersPage />;
  if (user.category === UserType.CANDIDATE) return <CandidatesPanel />;
  return <Spin fullscreen />;
};
  // For candidates, we'll navigate them in the useEffect};

export default DashboardPage;
